var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbleDotsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 6,
    viewBox: "0 0 26 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 13,
    cy: 3,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 23,
    cy: 3,
    r: 3,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleDotsDark);
export default __webpack_public_path__ + "static/media/bubble-dots-dark.95b745cc44cd132c339aa3d345f7ed8e.svg";
export { ForwardRef as ReactComponent };